/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Risk_Mod_OverloadInputs */

const en_coach_risk_mod_overload = /** @type {(inputs: Coach_Risk_Mod_OverloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are carrying deep fatigue and your load ramp is elevated. Your body is under significant stress. Easy days or complete rest are strongly recommended before resuming hard training.`)
};

const de_coach_risk_mod_overload = /** @type {(inputs: Coach_Risk_Mod_OverloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiefe Ermüdung bei erhöhter Belastungsrampe. Dein Körper steht unter erheblichem Stress. Lockere Tage oder komplette Ruhe — das ist jetzt das Wichtigste, bevor du wieder hart trainierst.`)
};

/**
* | output |
* | --- |
* | "You are carrying deep fatigue and your load ramp is elevated. Your body is under significant stress. Easy days or complete rest are strongly recommended befo..." |
*
* @param {Coach_Risk_Mod_OverloadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_risk_mod_overload = /** @type {((inputs?: Coach_Risk_Mod_OverloadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Risk_Mod_OverloadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_risk_mod_overload(inputs)
	return de_coach_risk_mod_overload(inputs)
});